import { LandingSeo } from 'src/feature/landing/components/LandingSeo';
import { LandingPage } from 'src/feature/landing/LandingPage';
import type { TStandalonePage } from 'src/feature/landing/standalone-page';

/**
 * Route: `/` — the Flex marketing landing page on flex.attendevents.com.
 *
 * No data fetching, so Next prerenders it at build time. Vanity domains never reach this
 * page: their `beforeFiles` rewrite maps `/` to `/<schema>/events_home` first.
 */
const FlexLandingPage: TStandalonePage = () => (
  <>
    <LandingSeo />
    <LandingPage />
  </>
);

FlexLandingPage.standalone = true;

export default FlexLandingPage;
